import moment from "moment";
import { OFFSETS } from '@/consts/globalization'

const clearUnixDate = (unix, isEndOfDay = false) => {
  if (typeof unix === "number") {
    const date = new Date(unix * 1000);

    if (isEndOfDay) {
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
    } else {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
    }

    date.setMilliseconds(0);
    return date.getTime() / 1000;
  }

  return 0;
};
const getUnixDate = (date, offset = 0) => {
  if (!date) return date;
  return Number(moment(date).utcOffset(offset).format("X"));
};
const formatDate = (timestamp, offset = 0, locale = "pt_BR") => {
  if (!timestamp) return;
  const format = locale === "en_US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
  return moment.unix(timestamp).utcOffset(offset).format(format);
};
const formatTime = (timestamp, offset = 0) => {
  if (!timestamp) return;
  return moment.unix(timestamp).utcOffset(offset).format("HH:mm:ss");
};
const formatDateTime = (timestamp, offset = 0) => {
  if (!timestamp) return;
  return moment.unix(timestamp).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss");
};
const formatDateLocale = (date, locale, offset = 0) => {
  const format = locale === "en_US" ? "MM/DD/YYYY" : "DD/MM/YYYY";
  return moment(date).utcOffset(offset).format(format);
};
const formatDateStyled = (timestamp, offset = 0) => {
  if (!timestamp) return;
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const d = timestamp ? moment.unix(timestamp).utcOffset(offset) : moment();
  return `${monthNames[d.format("M") - 1]} ${d.format("DD")}, ${d.format("YYYY")}`;
};

const getTimeZone = (offset) => {
  const timezone = OFFSETS.find((item) => item.value === offset);
  return timezone ? timezone.timezone : 'UTC';
};

const getDate = (unixTimestamp, locale, offset, timestyle) => {
  const convertedDate = unixTimestamp * 1000;
  const timezone = getTimeZone(offset);
  const parsedLocale = locale.replace('_', '-');
  const date = Intl.DateTimeFormat(parsedLocale, {
    dateStyle: 'short',
    timeStyle: timestyle,
    timeZone: timezone,
  }).format(convertedDate);
  return date.replace(',', ' -');
};

export {
  clearUnixDate,
  getUnixDate,
  formatDate,
  formatDateLocale,
  formatTime,
  formatDateTime,
  formatDateStyled,
  getTimeZone,
  getDate,
};
